export default __webpack_public_path__ + "static/media/logo_dark.fbd4acd3.svg";